import { OutOfService } from "@/App/style";
import { fetchPrismicDataIsServerOut } from "@/services/prismicService";
import { SettingTwoTone } from "@ant-design/icons";
import type { ReactNode } from "react";
import { useEffect, useState } from "react";

export const OutOfServiceProvider = ({
  children,
  title,
  subtitle
}: {
  children: ReactNode;
  title: string;
  subtitle: string;
}) => {
  const [isOutOfService, setIsOutOfService] = useState(false);
  useEffect(() => {
    fetchPrismicDataIsServerOut().then(setIsOutOfService).catch(console.error);
  }, []);

  if (isOutOfService)
    return (
      <OutOfService>
        <SettingTwoTone style={{ fontSize: "60px" }} spin={true} />
        <h1>{title}</h1>
        <h3>{subtitle}</h3>
      </OutOfService>
    );

  return <>{children}</>;
};
